import { useState, useEffect } from 'react';

export default function usePageScroll() {
  const [scrollPosY, setDetailSize] = useState(window.scrollY);

  function pageScroll() {
    setDetailSize(window.scrollY);
  }

  useEffect(() => {
    window.addEventListener('scroll', pageScroll);
    return () => {
      window.removeEventListener('scroll', pageScroll);
    };
  }, []);

  return scrollPosY;
}
